import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageReviewPlanogramCluster = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.ReviewClusterPlanogramPage />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageReviewPlanogramCluster = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageReviewPlanogramCluster />
    </Suspense>
  );
};
